<template>
  <div class="postscript">
    <el-collapse v-model="activeNames">
      <el-collapse-item name="list">
        <template #title>
          <span>
            <img src="../../assets/svg/postscript.svg" alt="" />
            附言
          </span>
        </template>
        <div>
          <div class="tableToolbar">
            <el-button type="text" icon="el-icon-plus" @click="addClick"
              >新增附言</el-button
            >
          </div>
          <el-table style="width: 100%" class="postscriptTable" ref="tableRef" stripe border :data="postscriptData">
            <el-table-column
              label="序号"
              type="index"
              width="60"
              align="center"
            ></el-table-column>
            <el-table-column
              label="附言内容"
              prop="content"
              min-width="200px"
            >
            </el-table-column>
            <el-table-column
              label="提交人"
              prop="name"
              width="110px"
              align="center"
            ></el-table-column>
            <el-table-column
              label="角色"
              prop="role"
              width="110px"
              align="center"
            ></el-table-column>
            <el-table-column
              label="提交日期"
              width="150px"
              prop="submitDate"
              align="center"
            ></el-table-column>
            <el-table-column label="附件" min-width="300px" prop="files">
              <template #default="{ row }">
                <div class="uploadFileInfo">
                  <div
                    v-for="(item, index) of row.files"
                    :key="index"
                    @click="filesClick(row.files, item)"
                  >
                    <div>
                      <img :src="getIoc(item, 'bigIoc')" alt="图片加载中..." />
                    </div>
                    <div
                      class="fileTitle"
                      v-if="!fileFormat.includes(getFileType(item))"
                      :title="item.fileName"
                    >
                      {{ item.fileName }}
                    </div>
                  </div>
                </div>
                <!-- <file-upload-list ref="fileUploadList" :fileList="row.files"></file-upload-list> -->
              </template>
            </el-table-column>
            <el-table-column label="操作" width="105px" align="center">
              <template #default="{ row, $index }">
                <el-button type="text" @click="editClick(row)">编辑</el-button>
                <el-button type="text" @click="deleteClick(row, $index)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <div class="fenye" v-if="total > 0">
            <pagination
              :total="total"
              :page.sync="currentPage"
              :limit.sync="pageSize"
              @pagination="pageOperation"
            />
          </div>
        </div>
        <el-dialog
          :title="dialogTitle"
          width="650px"
          :visible.sync="dialogFormVisible"
          :close-on-click-modal="false"
        >
          <!-- 新增留言 -->
          <el-form
            label-width="85px"
            ref="temp"
            :rules="rules"
            :model="temp"
            label-position="center"
            :validate-on-rule-change="false"
          >
            <el-form-item label="附言内容" prop="content">
              <el-input
                type="textarea"
                :autosize="{ minRows: 4, maxRows: 4 }"
                v-model="temp.content"
                placeholder="请输入附言内容"
                maxlength="500"
                show-word-limit
              ></el-input>
            </el-form-item>
            <el-form-item label="附件" prop="fileList">
              <drag-upload
                ref="uploadFile"
                :accessoryList.sync="temp.fileList"
                :httpRequest="action"
              />
            </el-form-item>
            <div class="dialog-footer-button">
              <el-button type="primary" @click="submitComment">提交</el-button>
              <el-button type="primary" plain @click="dialogFormVisible = false"
                >取消</el-button
              >
            </div>
          </el-form>
        </el-dialog>
      </el-collapse-item>
    </el-collapse>
    <!-- 预览图片视频组件 -->
    <view-img-video ref="viewRef" :list="fileInfoList" />
  </div>
</template>
<script>
import { previewFormat } from "@/util/qualityUtil/fileUpload";
import NewPolicyMessage from "@/views/feedbackNew/allCar/components/newPolicyMessage.vue";
import { addPostscript, auditHistoryList } from "@/api/feedback.js";
import { resolvePostRole } from "@/utils/role";
import viewImgVideo from "@/components/viewImgVideo.vue";
import {
  getThumbnailView,
  getPreviewInfo,
} from "@/util/qualityUtil/fileUpload";
export default {
  name: "postscript",
  components: {
    NewPolicyMessage,
    viewImgVideo,
  },
  data() {
    return {
      activeNames: ["list"], // 全部展开
      postscriptData: [],
      action: "/manage/car/feedback/question/upload/file?fileType=22",
      temp: {
        content: "",
        fileList: [],
      },
      rules: {
        content: [
          { required: true, message: "附言内容不能为空", trigger: "blur" },
        ],
      },
      dialogFormVisible: false,
      // fileList: [], // el-upload 的文件列表（用于界面展示）
      postscriptArray: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      dialogTitle: "新增附言",
      editIndex: "",
      fileInfoList: [],
      fileFormat: previewFormat,
    };
  },
  props: {
    postscriptInfo: {
      type: [Array, Object],
    },
  },
  computed: {
    currentTaskRoleName() {
      return (this.postscriptInfo && this.postscriptInfo.currentTaskRoleName) || "";
    },
    isCurrentTaskOwner() {
      const auditorId = this.postscriptInfo && this.postscriptInfo.currentTaskAuditorId;
      if (!auditorId) return false;
      const loginId = sessionStorage.getItem("staffAccountId");
      return !!loginId && String(loginId) === String(auditorId);
    },
  },
  mounted() {
    this.fetchCommentList();
  },
  methods: {
    // 获取图片类型
    getFileType(item) {
      var fileType = "";
      if (item.fileName) {
        fileType = item.fileName
          .substring(item.fileName.lastIndexOf(".") + 1)
          .toLowerCase();
      }
      return fileType;
    },
    // 缩略图图标
    getIoc(item, type) {
      return getThumbnailView(item, type);
    },
    // 图片视频预览
    filesClick(file, item) {
      getPreviewInfo(file, item, this);
    },
    // 重置数据
    resetTemp() {
      (this.temp = {
        content: "",
        fileList: [],
      }),
        this.$nextTick(function () {
          this.$refs.temp.resetFields();
        });
    },
    // 新增附言
    addClick() {
      this.dialogFormVisible = true;
      this.resetTemp();
      this.dialogTitle = "新增附言";
    },
    // 提交附言
    async submitComment() {
      this.$refs.temp.validate(async (valid, object) => {
        if (this.getRequiredValid(valid, object)){
          return
        }
        let postscriptData = {};
        const now = new Date(); // 获取当前时间
        // 补零函数（确保个位数显示为 01、02 等）
        const padZero = (num) => num.toString().padStart(2, "0");

        // 格式化成年-月-日 时:分:秒
        const formattedTime = `${now.getFullYear()}-${padZero(
          now.getMonth() + 1
        )}-${padZero(now.getDate())} ${padZero(now.getHours())}:${padZero(
          now.getMinutes()
        )}:${padZero(now.getSeconds())}`;
        if (this.dialogTitle == "编辑附言") {
          // 编辑附言
          const itemData = this.postscriptArray.find(
            (item) => item.index === this.editIndex
          );
          itemData.carQualityFeedbackAuditId =
            itemData.carQualityFeedbackAuditId;
          itemData.index = itemData.carQualityFeedbackAuditId;
          itemData.content = this.temp.content;
          itemData.files = this.temp.fileList;
          itemData.name = sessionStorage.getItem("name");
          itemData.submitDate = formattedTime;
        } else {
          // 新增附言
          var index = this.postscriptArray.length + 1;
          // 构造附言数据（注意：只序列化一次，避免双重转义）
          postscriptData = {
            carQualityFeedbackAuditId: this.$route.query.id || "",
            index: index,
            content: this.temp.content,
            files: this.temp.fileList,
            name: sessionStorage.getItem("name"),
            role: await resolvePostRole(this.currentTaskRoleName, { isOwner: this.isCurrentTaskOwner }),
            submitDate: formattedTime,
          };
        }
        //  提交附言（postscriptList 直接传对象的 JSON 字符串，不要二次序列化）
        await addPostscript({
          data: {
            questionId: this.postscriptInfo.questionId,
            postscriptList:
              this.dialogTitle == "编辑附言"
                ? JSON.stringify([...this.postscriptArray])
                : JSON.stringify([
                    ...[postscriptData],
                    ...this.postscriptArray,
                  ]),
          },
        });
        if (this.dialogTitle == "编辑附言") {
          this.$DonMessage.success("编辑附言成功！");
        } else {
          this.$DonMessage.success("新增附言成功！");
        }
        this.dialogFormVisible = false;
        // 提交成功后，重新获取附言数组（自动刷新附言窗口）
        await this.fetchCommentList();
      });
    },
    // 编辑附言
    editClick(row) {
      this.dialogFormVisible = true;
      this.resetTemp();
      this.$nextTick(() => {
        this.dialogTitle = "编辑附言";
        this.editIndex = row.index;
        this.temp = {
          content: row.content,
          fileList: row.files,
        };
      });
    },
    // 删除附言
    async deleteClick(row) {
      this.$confirm("确定删除当前附言吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        const index = this.postscriptArray.findIndex(
          (item) => item.index === row.index
        );
        if (index !== -1) {
          this.postscriptArray.splice(index, 1);
        }
        await addPostscript({
          data: {
            questionId: this.postscriptInfo.questionId,
            postscriptList: JSON.stringify([...this.postscriptArray]),
          },
        });
        this.$DonMessage.success("附言删除成功！");
        await this.fetchCommentList();
      });
    },
    // 获取附言列表
    async fetchCommentList() {
      try {
        const res = await auditHistoryList({
          data: {
            questionId: this.postscriptInfo.questionId,
          },
        });
        this.privateList = res.data || []; // 审核历史列表（确保是数组）
        if (this.privateList.length > 0) {
          const rawPostscriptStr = this.privateList[0].postscriptList || "";
          // this.postscriptArray = this.fixRawJson(rawPostscriptStr);
          this.postscriptArray = JSON.parse(rawPostscriptStr) || [];
          if (!Array.isArray(this.postscriptArray)) {
            this.postscriptArray = [this.postscriptArray];
          }
          this.total = this.postscriptArray.length;
          this.pageOperation();
        } else {
          this.privateList = [];
          this.postscriptArray = []; // 无审核记录时，附言数组为空
        }
      } catch (error) {
        //   console.error("获取/解析附言失败：", error);
        this.privateList = [];
        this.postscriptArray = [];
        //   // this.$DonMessage.error("获取附言列表失败");
      }
    },
    // 分页
    pageOperation() {
      var allList = this.postscriptArray;
      let start = this.pageSize * (this.currentPage - 1);
      let end = this.pageSize * this.currentPage;
      if (allList.length > end) {
        this.postscriptData = allList.slice(start, end);
      } else if (allList.length > start) {
        this.postscriptData = allList.slice(start, allList.length);
      } else {
        this.postscriptData = [];
      }
    },
  },
};
</script>
<style scoped>
::v-deep .el-table.postscriptTable .el-table__cell .cell {
  white-space: normal;
  word-break: break-word;
}
</style>
